import React, { useState } from 'react'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { Button, DialogActions, makeStyles } from '@material-ui/core'
import { Modal } from 'asterX-UI/Modals'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import RedirectClient from 'pages/Desktop/Selection/Manager/components/RedirectClient'
import CarData from 'components/Desktop/Car/CarData'
import CarSelectionCard from 'components/Desktop/Car/CarSelectionCard'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative'
  },
  buttonBar: {
    display: 'flex',
    position: 'absolute',
    justifyContent: 'space-between',
    width: '100%'
  },
  rootDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 20,
    position: 'relative',
    height: '80vh'
  }
}))
const CarSelection = () => {
  const [activeCar, setActiveCar] = useState(null)
  const [loading, setLoading] = useState(false)
  const classes = useStyles()
  const {
    store: { demonstratedCars, selectedCarForSale },
    funcs: { goNextStep, handleSelectCarForSale }
  } = useSelectionStore()

  const handleCarClick = car => {
    setActiveCar(car)
  }
  const selectCar = car => async () => {
    handleCarClick(null)
    setLoading(true)
    await handleSelectCarForSale(car)
    setLoading(false)
  }
  const getDemonstrationResults = vin => {
    const car = demonstratedCars?.find(car => car.vin === vin)
    if (car) {
      return {
        resultConfiguration: car?.resultConfiguration,
        resultExternal: car?.resultExternal,
        resultPrice: car?.resultPrice,
        resultTechnical: car?.resultTechnical,
        resultTestDrive: car?.resultTestDrive,
        resultTestDriveExpress: car?.resultTestDriveExpress,
        resultCarNotDemonstrated: car?.resultCarNotDemonstrated,
        comment: car?.comment
      }
    }
    return null
  }
  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={loading} />
      <div className={classes.rootDiv}>
        {demonstratedCars?.map(car => (
          <CarSelectionCard
            car={car}
            onClick={() => handleCarClick(car)}
            isChoosen={selectedCarForSale?.vin === car?.vin}
          />
        ))}
      </div>
      <div className={classes.buttonBar}>
        <div></div>
        <Button
          variant={'contained'}
          color={'primary'}
          onClick={goNextStep}
          disabled={!selectedCarForSale?.vin}
        >
          Продолжить
        </Button>
      </div>
      {activeCar?.id && (
        <Modal
          fullWidth
          maxWidth={'md'}
          open={activeCar}
          onClose={() => handleCarClick(null)}
        >
          <CarData
            vin={activeCar.vin}
            onClose={() => handleCarClick(null)}
            demonstrationResults={getDemonstrationResults(activeCar.vin)}
          />
          {selectedCarForSale?.vin !== activeCar?.vin && (
            <DialogActions>
              <Button
                fullWidth
                size={'medium'}
                variant={'contained'}
                color={'primary'}
                onClick={selectCar(activeCar)}
              >
                Выбрать
              </Button>
            </DialogActions>
          )}
        </Modal>
      )}
    </div>
  )
}
export default CarSelection
